/**
 * @author: 陈基涛
 * @date: 2022
 * @description: 返回环境类型，注意是 {string}
 * * 随着时光的变迁，灰度环境越来越不被人所提起
 * * 0：47, 1：67, 2：灰度, 3：生产
 */
const runType = (() => {
  let runType = '0'

  const hostname = window.location.hostname
  const href = window.location.href
  const isHttps = window.location.protocol === 'https:'

  if (['localhost', 'dev.www.phone580.com'].includes(hostname)) {
    runType = '0'
  } else if (['127.0.0.1', 'test.s.phone580.com', 'test.www.phone580.com', '10.20.8.73'].includes(hostname)) {
    runType = '1'
  } else if (isHttps && href.includes('/test')) {
    runType = '2'
  } else if (isHttps && !href.includes('/test')) {
    runType = '3'
  }

  return runType
})()

export default runType
